// Lightweight country list + flag helper based on `world-countries`.
// Returns a stable list of objects: { code, name, flag, dialCode }
import countries from 'world-countries';

// ISO-2 → emoji flag — works in all modern browsers, falls back to country code.
const flagFor = (cca2) => {
  if (!cca2 || cca2.length !== 2) return '';
  // Regional Indicator Symbols
  const A = 0x1f1e6;
  const a = 'A'.charCodeAt(0);
  return String.fromCodePoint(A + cca2.charCodeAt(0) - a, A + cca2.charCodeAt(1) - a);
};

// Build a sorted list of every country known to ISO-3166.
export const ALL_COUNTRIES = countries
  .map((c) => ({
    code: c.cca2,
    cca3: c.cca3,
    name: c.name.common,
    official: c.name.official,
    flag: flagFor(c.cca2),
    // First international dial code, e.g. "+49"
    dialCode: c.idd && c.idd.root
      ? c.idd.root + (Array.isArray(c.idd.suffixes) && c.idd.suffixes.length === 1 ? c.idd.suffixes[0] : '')
      : '',
    region: c.region,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const COUNTRY_BY_CODE = Object.fromEntries(ALL_COUNTRIES.map((c) => [c.code, c]));
export const COUNTRY_BY_NAME = Object.fromEntries(ALL_COUNTRIES.map((c) => [c.name.toLowerCase(), c]));
